export const userRoles = Object.freeze({
    clubOwner: "ROLE_ADMIN",
    coach: "ROLE_COACH",
    user: "ROLE_USER",
    clubStaff: "ROLE_STAFF",
    guest: "ROLE_GUEST"
    
})

export const isClubOwner = (userInfo) => userInfo?.authorities?.some(item=>item.roleName===userRoles.clubOwner);
export const isClubStaff = (userInfo) => userInfo?.authorities?.some(item => item.roleName ===userRoles.clubStaff);
export const isCoach = (userInfo) => userInfo?.authorities?.some(item => item.roleName ===userRoles.coach);
export const isUser = (userInfo) => userInfo?.authorities?.some(item => item.roleName ===userRoles.user);
export const isGuest = (userInfo) => userInfo?.authorities?.some(item => item.roleName ===userRoles.guest);



//// BOTTOM NO LONGER REQUIRED

const friendlyRoleNames = {
    [userRoles.clubOwner]: "ADMIN",
    [userRoles.clubStaff]: "STAFF",
    [userRoles.coach]: "COACH",
    [userRoles.user]: "PLAYER"
  };

  

  const rolePriority = [
    userRoles.user,       // ROLE_USER
    userRoles.coach,      // ROLE_COACH
    userRoles.clubStaff,  // ROLE_STAFF
    userRoles.clubOwner,  // ROLE_ADMIN
  ];
  
  export const getHighestRole = (userInfo) => {

   // console.log("userInfo", userInfo);
    if (!userInfo?.authorities?.length) return null;
  
    const assignedRoles = userInfo.authorities
      .map(a => a?.roleName?.trim())
      .filter(Boolean);


     // console.log("assignedRoles", assignedRoles);
  
    for (let i = rolePriority.length - 1; i >= 0; i--) {
      if (assignedRoles.includes(rolePriority[i])) {
        return friendlyRoleNames[rolePriority[i]] || null; // return friendly name
      }
    }
  
    return null;
  };
  
  
  
  